var bxslider_slider = [];
var bxslider_inc;
var bxslider_slider_el;
var grid;

jQuery(document).ready(function() {
	

    jQuery('.c-primary_nav__list').on('click', '> .open > a', function() {
        location.href = this.href;
    });
    
    /*
    jQuery('.c-primary_nav__list > li').on('mouseenter ', function(e) {
        var this_el = jQuery(this);
        e.stopPropagation();
        jQuery(this).addClass("open");
        align_menu();
    });

    jQuery('.c-primary_nav__list > li').on('mouseleave ', function(e) {
        var this_el = jQuery(this);
        e.stopPropagation();
        jQuery(this).removeClass("open");
        align_menu();
    });
    */

    /*
    jQuery(".c-logo, .c-primary_nav__list a").on("click touchend", function(e) {
        var el = jQuery(this);
        var link = el.attr("href");
        window.location = link;
        jQuery('html').removeClass('nav-open');
    });
    */

    /*
    jQuery('.c-primary_nav__list li').hover(function() {
        if ( jQuery(this).find('> ul').length > 0) {
            jQuery(this).find('> ul').slideDown();
            align_menu();
        }
    }, function() {
        if ( jQuery(this).find('> ul').length > 0) {
            jQuery(this).find('> ul').slideUp();
        }
    });
    */

	jQuery('.c-bxslider__wrap').each(function(i) {

        bxslider_inc = i;
        bxslider_slider_el = jQuery(this);

        if (bxslider_slider_el.find('.c-bxslider__slide').length > 1) {
            bxslider_slider_el.parents('.c-bxslider').find('.c-bxslider__nav a').fadeIn();
            bxslider_slider_el.parents('.c-bxslider').find('.c-bxslider__nav').fadeIn();
            bxslider_slider_el.parents('.c-bxslider').find('.c-bxslider__nav-btns').fadeIn();
            
            bxslider_slider[i] = bxslider_slider_el.bxSlider({
                mode: 'horizontal',
                controls: false,
                pager: false,
                auto: true,
                pause: 6000,
                touchEnabled: true,
                autoReload: true,
                breaks: [{screen:0, slides:1, pager:false},{screen:740, slides:2},{screen:980, slides:3}],
                onSlideAfter: function($slideElement, oldIndex, newIndex){
                   

                },
                onSlideBefore: function($slideElement,oldIndex,newIndex) {
                    

                }
            });

            bxslider_slider_el.parents('.c-bxslider').find('.c-bxslider__left').click(function() {
                bxslider_slider[i].goToPrevSlide();
                return false;
            });

            bxslider_slider_el.parents('.c-bxslider').find('.c-bxslider__right').click(function() {
                bxslider_slider[i].goToNextSlide();
                return false;
            });

        }

    });

    jQuery(document).on('click', '[data-jump]', function() {

       var target = jQuery(this).data('jump');

       if (jQuery(target).length > 0) {
        var top = jQuery(target).position().top;
        jQuery('html, body').animate({scrollTop : top})
       }

       return false;

    });

    if ( jQuery('.c-testimonials__item').length > 1) {

        grid = jQuery('.c-testimonials');

        grid.isotope({
          itemSelector: '.c-testimonials__item',
          layoutMode: 'fitRows'
        });

        grid.on( 'arrangeComplete', function( event, filteredItems ) {
          //var pos_top = jQuery('#c-testimonialsAnchor').position().top;
          //jQuery('html, body').animate({scrollTop: pos_top});
          widgets_sticky();
        });

        jQuery(document).on('click', '[data-isotopeslug]', function() {
            var target = jQuery(this).data('isotopeslug');
            jQuery('[data-isotopeslug]').removeClass('active');
            jQuery(this).addClass('active');

            if (target == 'all') {
                grid.isotope({ filter: "*"});
            } else {
                grid.isotope({ filter: target});
            }

        });

    }

});

jQuery(window).load(function() {
    jQuery('#page-loader').fadeOut();
});

jQuery(document).on("click", ".c-header__navtoggle", function() {
    jQuery('html').toggleClass('nav-open');

    jQuery('html,body').animate({scrollTop: 0});

    return false;
});

// BIOS TOGGLE
jQuery(document).on('click', '.c-bios__bio', function() {
    var parent = jQuery(this).parents('.c-bios');
    parent.find('.c-bios__toggleContent').not(jQuery(this).find('.c-bios__toggleContent')).slideUp();

    jQuery(this).find('.c-bios__toggleContent').slideToggle();

});

jQuery(document).on('click', function(e) {
    var el = jQuery(e.target);
    
    // Is nav element
    if (el.parents('.c-primary_nav__list').length > 0) {
        
        if ( el.next('.sub-menu').length > 0 ) {
        
            if ( el.parents('.sub-menu').length > 0 ) {
                
            } else {
                el.parents('.c-primary_nav__list').find('.open').removeClass('open');
            }


            if ( el.next('.sub-menu').not(":visible").length > 0 ) {
                el.parents('.sub-menu').find('.open').removeClass('open');

                el.parent('li').addClass('open');
                align_menu();
                return false;
            }

            
        }

    } else {
        jQuery('.c-primary_nav__list').find('.open').removeClass('open');
    }
});

jQuery(window).resize(function() {
    align_menu();
});

// CHECK MENU DROPDOWN ALIGNMENT
function align_menu() {
    jQuery('.c-primary_nav__list > li > .sub-menu').each(function() {
        var el = jQuery(this);
        el.removeClass('right_align');
        var menu_offset = el.offset().left
        var menu_width = el.width();
        var win_width = jQuery(window).width();

        if ( (menu_offset + menu_width) > win_width ) {
            el.addClass('right_align');
        } else {
            el.removeClass('right_align');
        }

    });
}

// STICKY WIDGETS
var orig_pos;
var widgets_top;
var offset_scroll;
var available_scroll;
function widgets_sticky() {

    if ( !orig_pos ) {
        jQuery('.c-widgets--sticky').parents('.sticky-holder').removeClass('sticky');
        jQuery('.c-widgets--sticky').css({'top': '0px'});
        orig_pos = jQuery('.c-widgets--sticky').position().top;
        widgets_top = orig_pos - 50;
    }

    available_scroll = (jQuery('.c-main').innerHeight() ) - jQuery('.c-widgets--sticky').outerHeight();

    if ( jQuery(window).scrollTop() > widgets_top ) {
        offset_scroll = jQuery(window).scrollTop() - widgets_top;
        if ( available_scroll > offset_scroll) {
            var newScroll = jQuery(window).scrollTop() - widgets_top;
            jQuery('.c-widgets--sticky').css({'transform': 'translateY('+newScroll+'px)','-webkit-transform': 'translateY('+newScroll+'px)'});
        } else {

        }

    } else {
        jQuery('.c-widgets--sticky').css({'transform': 'translateY(0px)','-webkit-transform': 'translateY(0px)'});
    }
}

jQuery(window).scroll(function() {
    if ( jQuery('.c-widgets--sticky').length > 0 ) {
        widgets_sticky();
    }
});

jQuery(window).load(function() {
    if ( jQuery('.c-widgets--sticky').length > 0 ) {
        widgets_sticky();
    }
});

jQuery(window).resize(function() {
    orig_pos = false;
});

function isEven(value) {
    if (value%2 == 0)
        return true;
    else
        return false;
}
